import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import { formatRotterdamClockTime } from './rotterdam-time'
import './footer.css'

const LOCATION_TEXT = 'Rotterdam, NL'
const SCRAMBLE_CHARACTERS = '!<>-_\\/[]{}—=+*^?#________'
const SCRAMBLE_FRAMES = 12
const SCRAMBLE_INTERVAL = 40

const createScrambledText = (length) =>
  Array.from(
    { length },
    () =>
      SCRAMBLE_CHARACTERS[
        Math.floor(Math.random() * SCRAMBLE_CHARACTERS.length)
      ]
  ).join('')

const Footer = (props) => {
  const [currentTime, setCurrentTime] = useState(() => new Date())
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [locationDisplay, setLocationDisplay] = useState(LOCATION_TEXT)
  const hasMountedInteraction = useRef(false)
  const isScrambling = useRef(false)
  const showLocalTime = isHovered || isFocused

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => window.clearInterval(intervalId)
  }, [])

  const rotterdamClockTime = formatRotterdamClockTime(currentTime)

  useEffect(() => {
    if (!hasMountedInteraction.current) {
      hasMountedInteraction.current = true
      return undefined
    }

    let frame = 0
    const targetLength = (
      showLocalTime ? formatRotterdamClockTime(new Date()) : LOCATION_TEXT
    ).length

    isScrambling.current = true
    setLocationDisplay(createScrambledText(targetLength))

    const intervalId = window.setInterval(() => {
      if (frame < SCRAMBLE_FRAMES) {
        setLocationDisplay(createScrambledText(targetLength))
        frame += 1
        return
      }

      window.clearInterval(intervalId)
      isScrambling.current = false

      if (showLocalTime) {
        const resolvedTime = new Date()
        setCurrentTime(resolvedTime)
        setLocationDisplay(formatRotterdamClockTime(resolvedTime))
      } else {
        setLocationDisplay(LOCATION_TEXT)
      }
    }, SCRAMBLE_INTERVAL)

    return () => window.clearInterval(intervalId)
  }, [showLocalTime])

  useEffect(() => {
    if (showLocalTime && !isScrambling.current) {
      setLocationDisplay(rotterdamClockTime)
    }
  }, [rotterdamClockTime, showLocalTime])

  return (
    <footer className={`footer-thq-footer-elm ${props.rootClassName} `}>
      <div className="footer-container10">
        <div className="footer-container11">
          <Link to="/" className="footer-navlink1">
            <span>VLAD BUTUCARIU /</span>
            <br></br>
          </Link>
        </div>
        <div className="footer-thq-footer-menu-elm">
          <div className="footer-container12">
            <Link to="/work" className="footer-navlink2">
              Work
            </Link>
            <Link to="/services" className="footer-navlink3">
              Capabilities
            </Link>
            <Link to="/about" className="footer-navlink4">
              About
            </Link>
            <Link to="/contact" className="footer-navlink5">
              Contact
            </Link>
          </div>
          <div className="footer-container13">
            <span
              id="rotterdam-time"
              className="footer-container14"
              tabIndex={0}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label={
                showLocalTime
                  ? `Current local time in Rotterdam, Netherlands: ${rotterdamClockTime}`
                  : 'Rotterdam, Netherlands. Focus to show local time.'
              }
            >
              {locationDisplay}
            </span>
          </div>
        </div>
        <div className="footer-container17">
          <div className="footer-container18">
            <span className="footer-text4">{props.text}</span>
            <span className="footer-date-time">{new Date().getFullYear()}</span>
          </div>
          <div className="footer-container19">
            <div className="footer-container20">
              <div className="footer-container21">
                <React.Fragment>
                  <Script>{`
  (function(){
  const statusText = document.querySelector('.status-text');
  const trigger = statusText.parentElement; // We trigger hover on the parent container
  const chars = '!<>-_\\/[]{}—=+*^?#________'; 
  
  let interval;
  const duration = 12; // Duration of glitch in frames

  // Reusable function to drive the animation
  function animateText(targetText, targetColor) {
    let frame = 0;
    
    // 1. Set the color immediately
    statusText.style.color = targetColor;
    statusText.style.transition = "color 0.2s ease";
    
    // 2. Clear any running animation to prevent conflicts
    clearInterval(interval);
    
    interval = setInterval(() => {
      // 3. Scramble Logic
      if (frame < duration) {
        // Generate random characters matching the length of the TARGET text
        // This ensures the width expands/contracts during the glitch
        const scrambled = targetText.split('')
          .map(() => chars[Math.floor(Math.random() * chars.length)])
          .join('');
        
        statusText.innerText = scrambled;
        frame++;
      } else {
        // 4. Resolve to final text and stop
        statusText.innerText = targetText;
        clearInterval(interval);
      }
    }, 40); // Speed (ms)
  }

  // Event Listeners
  trigger.addEventListener('mouseenter', () => {
    animateText("Available_For_Work", "#00FF41");
  });

  trigger.addEventListener('mouseleave', () => {
    animateText("Operational", "#595959");
  });
})();
`}</Script>
                </React.Fragment>
              </div>
            </div>
            <span className="footer-thq-status-text-elm status-text">
              Operational
            </span>
            <span className="footer-text5"></span>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  text: 'Copyright',
  rootClassName: '',
}

Footer.propTypes = {
  text: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Footer
